// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

// The one place a priced figure is turned into text (Joel, 2026-10-07): engineering style, the decimals always
// shown — dollars to two ($1,250.50), dollars per foot to four ($2.0000/ft, how our customers think), percentages
// and credits to two. A value that is an integer by design (a promotion's whole percent, the license-fee percent,
// a count, a spend-band threshold) is printed as it is and does not come through here.

const fixed = (value: number, digits: number): string => (Number.isFinite(value) ? value : 0).toLocaleString('en-US', {
  minimumFractionDigits: digits,
  maximumFractionDigits: digits,
});

const signed = (value: number, text: string): string => (value < 0 ? `-$${text}` : `$${text}`);

// $1,250.50 · -$5.00
export const dollars = (value: number): string => signed(value, fixed(Math.abs(value), 2));

// $2.0000/ft
export const dollarsPerFoot = (value: number): string => `${signed(value, fixed(Math.abs(value), 4))}/ft`;

// 25.33%
export const percent = (value: number): string => `${fixed(value, 2)}%`;

// 1,234.50 — the unit is the caller's ("credits", "cr")
export const credits = (value: number): string => fixed(value, 2);
